import { render, staticRenderFns } from "./PharmacyChart.vue?vue&type=template&id=1ab98284"
import script from "./PharmacyChart.vue?vue&type=script&lang=js"
export * from "./PharmacyChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports